// import { useState, useCallback } from "react";

const useDayFormat = () => {
  return [];
};

export default useDayFormat;
